<template>
  <div class="app-main-content">
    <sales-query-tree-grid
      v-show="view==='list'"
      ref="salesQueryTreeGrid"
      :context="context"
      :is-sales-for-szfs="isSalesForSzfs"
      @look="lookHandle"
    />
    <sales-query-workspace
      v-show="view==='detail'"
      ref="salesQueryWorkspace"
      :parent-context="context"
      :is-sales-for-szfs="isSalesForSzfs"
      @back="backToList"
    />
  </div>
</template>

<script>
import { SalesQueryContext } from './components/salesQuery/salesQueryContext'
import salesQueryTreeGrid from './components/salesQuery/salesQueryTreeGrid'
import salesQueryWorkspace from './components/salesQuery/salesQueryWorkspace'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'SalesQuery',
  components: { salesQueryTreeGrid, salesQueryWorkspace },
  data() {
    return {
      context: SalesQueryContext.getInstance(),
      view: 'list',
      jumpActiveTabName: 'tabCharges'
    }
  },
  computed: {
    office() {
      return this.context.office
    },
    // 深圳丰收销售专用
    isSalesForSzfs() {
      return String(cache.config.get('ToExoSystem')) === 'SZFS' && !this.$store.getters.isAdmin &&
        (this.$checkPermission(['role_salesOfGoods']) || this.$checkPermission(['role_RemoteBooking_queryPrivateCustom']) ||
          this.$checkPermission(['role_platform_sales']) || this.$checkPermission(['role_branchSales']) || this.$checkPermission(['role_sales']))
    }
  },
  activated() {
    if (this.$route.params.businessNo) {
      this.jumpActiveTabName = 'tabCharges'
      this.$refs.salesQueryTreeGrid.toSimpleQuery(this.$route.params.businessNo)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.context.prepareData()
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    lookHandle(row) {
      if (this.jumpActiveTabName) {
        this.$refs.salesQueryWorkspace.activeTabName = this.jumpActiveTabName
        this.jumpActiveTabName = ''
      }
      this.detailHandle('look', row)
    },
    backToList(isRefresh) {
      this.view = 'list'
      if (isRefresh) {
        // this.$refs.salesQueryTreeGrid.toQuery()
      }
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.salesQueryWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.salesQueryTreeGrid.rowData
      }
      this.$refs.salesQueryWorkspace.onShow(type, rowData, row)
    }
  }
}
</script>

<style lang="scss">
</style>
